import React from 'react';

const BasePage: React.FC = ({ children }) =>
    <div className="wrapper" style={{backgroundColor: "#082550"}}>{children}</div>;

export default BasePage;
